import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import "./lib/preloadWill";
import { captureAttribution } from "./lib/utm";
import { installOfflineFetchGuard } from "./lib/network";
import { registerOfflineSW } from "./lib/registerSW";

// Capture UTM / referrer on first landing so we can see which channels drive signups.
captureAttribution();

// Offline support: cache the app shell, and surface "No Wifi" for online-only features.
installOfflineFetchGuard();
registerOfflineSW();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
